import React from "react";
import ContactSection from "@/components/sections/ContactSection";
import BigCTA from "@/components/sections/BigCTA";

export default function ContactPage() {
  return (
    <main data-testid="contact-page" className="pt-36 md:pt-44">
      <section className="container-x pb-6">
        <div className="max-w-3xl">
          <h1 className="text-[36px] md:text-[56px] font-extrabold text-navy leading-[1.1]">Contact Velixa Health</h1>
          <p className="mt-5 text-ink/85 text-[18px] max-w-2xl">Call, WhatsApp or fill the form — we're available 24/7 across Bangalore.</p>
        </div>
      </section>
      <ContactSection />
      <BigCTA />
    </main>
  );
}
